import { IRootState } from '../../types/redux/root';

export const commentariesListSelector = (dataIndex?: string) => (root: IRootState) => (typeof dataIndex === 'string' ? root.commentaries[dataIndex] || [] : []);
